<section class="cta-wrap relative mt-10 md:mt-16 lg:mt-20 pb-6 px-4">
  <div class="container-layout">
    <div class="grid justify-content-center">
      <div class="col-12 lg:col-10 xl:col-9">
        
        <!-- Card Moderno e Horizontal (Dark Theme para contraste) -->
        <div class="relative overflow-hidden border-round-3xl shadow-8 bg-gray-900 text-white p-5 md:p-7 transition-transform hover:-translate-y-1 transition-duration-300">
            
            <!-- Background Effects -->
            <div class="absolute top-0 right-0 w-30rem h-30rem bg-orange-500 border-circle opacity-10 blur-3xl pointer-events-none" style="transform: translate(30%, -30%);"></div>
            <div class="absolute bottom-0 left-0 w-20rem h-20rem bg-primary-700 border-circle opacity-10 blur-3xl pointer-events-none" style="transform: translate(-30%, 30%);"></div>

            <div class="grid align-items-center relative z-2">
                <!-- Coluna Texto -->
                <div class="col-12 md:col-7 lg:col-8 text-center md:text-left">
                    <h2 class="text-2xl md:text-3xl lg:text-4xl font-extrabold mb-2 text-white letter-spacing-tight line-height-tight">
                        Gerencie seu evento com <span class="text-orange-500">facilidade e segurança</span>
                    </h2>
                    <p class="text-gray-400 text-base md:text-lg line-height-3 mb-4 max-w-30rem mx-auto md:mx-0">
                        A plataforma completa para produtores exigentes. Venda ingressos, acompanhe resultados em tempo real e receba seus pagamentos rapidamente.
                    </p>
                    
                    <div class="flex flex-column sm:flex-row gap-3 justify-content-center md:justify-content-start">
                        <button 
                            pButton 
                            pRipple
                            label="Começar Agora" 
                            icon="pi pi-arrow-right" 
                            iconPos="right"
                            class="p-button bg-gradient-brand border-none border-round-lg px-4 py-0 text-sm md:text-base font-bold shadow-4 hover:shadow-6 w-full sm:w-auto justify-content-center h-3rem flex align-items-center"
                            (click)="onCreateEventClick()">
                        </button>
                        <button 
                            pButton 
                            pRipple
                            label="Conhecer a Plataforma" 
                            icon="pi pi-play-circle"
                            class="p-button-outlined p-button-secondary border-round-lg px-4 py-0 text-sm md:text-base font-bold hover:surface-white hover:text-gray-900 transition-colors w-full sm:w-auto justify-content-center text-white border-gray-600 h-3rem flex align-items-center"
                            (click)="onHowItWorksClick()">
                        </button>
                    </div>

                    <!-- Features Mini -->
                    <div class="flex flex-wrap justify-content-center md:justify-content-start gap-4 mt-5 text-xs md:text-sm text-gray-400 font-medium">
                        <div class="flex align-items-center gap-2">
                            <div class="w-1rem h-1rem border-circle bg-green-500 flex align-items-center justify-content-center flex-shrink-0">
                                <i class="pi pi-check text-gray-900 text-xs font-bold" style="font-size: 0.6rem"></i>
                            </div>
                            <span>Dashboard Intuitivo</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <div class="w-1rem h-1rem border-circle bg-green-500 flex align-items-center justify-content-center flex-shrink-0">
                                <i class="pi pi-check text-gray-900 text-xs font-bold" style="font-size: 0.6rem"></i>
                            </div>
                            <span>Relatórios Detalhados</span>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <div class="w-1rem h-1rem border-circle bg-green-500 flex align-items-center justify-content-center flex-shrink-0">
                                <i class="pi pi-check text-gray-900 text-xs font-bold" style="font-size: 0.6rem"></i>
                            </div>
                            <span>Check-in Rápido</span>
                        </div>
                    </div>
                </div>

                <!-- Coluna Ícone/Imagem (Decorativa - Não Clicável) -->
                <div class="col-12 md:col-5 lg:col-4 hidden md:flex justify-content-center align-items-center pl-4 select-none">
                    <div class="relative w-10rem h-10rem lg:w-12rem lg:h-12rem border-round-2xl bg-gradient-brand flex align-items-center justify-content-center shadow-8 rotate-6 hover:rotate-3 transition-transform transition-duration-500 border-2 border-white-alpha-20">
                        <i class="pi pi-chart-bar text-5xl lg:text-6xl text-white"></i>
                        <!-- Badge flutuante -->
                        <div class="absolute -bottom-3 -left-4 bg-gray-800 text-white px-3 py-2 border-round-xl shadow-4 font-bold text-xs border-1 border-gray-700 flex align-items-center gap-2">
                            <i class="pi pi-star-fill text-yellow-500"></i>
                            <span>Alta Conversão</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
      </div>
    </div>
  </div>
</section>
